import angular from 'angular';

export default angular.module('shared').constant('asuiTableTemplateResources', {
    supportCaseHistoryDefault: `<div>{0}</div>`,
    supportCaseHistoryIcon: `<div class='status {{item.status | lowercase}}'><div class='icon-case'></div></div>`,
    supportCaseHistoryLink: `<a ui-sref="support_viewcase({caseId: item.id})">{0}</a>`
});



// WEBPACK FOOTER //
// ./modules/shared/constants/asuiTableTemplateResources.constant.js